import { create } from 'zustand'
import { ContactListItem, Scope } from '@utils'
import { v4 as uuid } from 'uuid';
import { useContactMappingStore } from './useContactMappingStore';

export const mockMe: ContactListItem = {
  id: 'me',
  gender: 'male',
  firstName: 'Nomena Faliana',
  lastName: 'Soloniaina',
  fullName: 'Soloniana Nomena Faliana',
  avatarUrl: 'https://randomuser.me/api/portraits/men/1.jpg',
  hashtags: ['#friends', '#nature', '#work'],
}

// Données mock par défaut pour les tests
export const mockContactsList: ContactListItem[] = [
  {
    id: '1',
    gender: 'male',
    firstName: 'Olivier',
    lastName: 'Dubois',
    fullName: 'Olivier Dubois',
    avatarUrl: 'https://randomuser.me/api/portraits/men/1.jpg',
    hashtags: ['#business', '#tech'],
    birthDate: '06-08-2025',
    facebook: 'facebook.com'
  },
  {
    id: '2',
    gender: 'male',
    firstName: 'Olivier',
    lastName: 'Martin',
    fullName: 'Olivier Martin',
    avatarUrl: 'https://randomuser.me/api/portraits/men/2.jpg',
    hashtags: ['#marketing', '#social'],
    birthDate: '05-08-2025',
    facebook: 'facebook.com',
    instagram: 'insta.com'
  },
  {
    id: '3',
    gender: 'male',
    firstName: 'Pierre',
    lastName: 'Bernard',
    fullName: 'Pierre Bernard',
    avatarUrl: 'https://randomuser.me/api/portraits/men/3.jpg',
    hashtags: ['#work', '#travel'],
    birthDate: '06-08-2025',
    facebook: 'facebook.com',
    instagram: 'insta.com',
    twitter: 'twitter.com'
  },
  {
    id: '4',
    gender: 'male',
    firstName: 'Olivier',
    lastName: 'Laurent',
    fullName: 'Olivier Laurent',
    avatarUrl: 'https://randomuser.me/api/portraits/men/4.jpg',
    hashtags: ['#business', '#management'],
    birthDate: '07-08-2025',
    facebook: 'facebook.com'
  },
]
// Interface du store
interface UseContactsListStoreState {
  me: ContactListItem
  contacts: ContactListItem[]
  isLoading: boolean
  error: string | null
  
  // Actions CRUD
  addContact: (contact: Omit<ContactListItem, 'createdAt' | 'updatedAt'>, scope: Scope[]) => void
  updateProfile: (updates: Partial<Omit<ContactListItem, 'id' | 'createdAt' | 'updatedAt'>>) => void
  updateContact: (id: string, updates: Partial<Omit<ContactListItem, 'id' | 'createdAt' | 'updatedAt'>>) => void
  deleteContact: (id: string) => void
  getContactById: (id: string) => ContactListItem | undefined
  
  // Actions de filtrage
  getAllContacts: () => ContactListItem[]
  searchContacts: (searchText: string, scope?: Scope[]) => ContactListItem[]
  
  // Actions utilitaires
  getContactsCount: () => number
  
  // Actions de gestion d'état
  setLoading: (loading: boolean) => void
  setError: (error: string | null) => void
  resetContacts: () => void
}

// Fonction utilitaire pour générer un ID unique
const generateId = (): string => {
  return uuid()
}

// Store Zustand avec persistance
export const useContactsListStore = create<UseContactsListStoreState>()(
  //persist(
    (set, get) => ({
      me: mockMe,
      contacts: mockContactsList,
      isLoading: false,
      error: null,

      // Actions CRUD
      addContact: (contactData, scope) => {
        const newContact: ContactListItem = {
          ...contactData,
          id: contactData.id /* for extension */ || generateId()
        }
        
        set((state) => ({
          contacts: [...state.contacts, newContact],
          error: null,
        }))

        useContactMappingStore.getState().addContact({
          id: newContact.id,
          scope
        })
      },
      updateProfile: (updates) => {
        set((state) => ({
          me: {...state.me, ...updates, updatedAt: new Date().toISOString()}
        }))
      },
      updateContact: (id, updates) => {
        set((state) => ({
          contacts: state.contacts.map((contact) =>
            contact.id === id
              ? { ...contact, ...updates, updatedAt: new Date().toISOString() }
              : contact
          ),
          error: null,
        }))
      },

      deleteContact: (id) => {
        set((state) => ({
          contacts: state.contacts.filter((contact) => contact.id !== id),
          error: null,
        }))
      },

      getContactById: (id) => {
        return get().contacts.find((contact) => contact.id === id)
      },

      getAllContacts: () => {
        return get().contacts
      },

      searchContacts: (searchText, scope) => {
        const contacts = get().contacts
        let filteredContacts = contacts

        // Filtrer par texte de recherche
        if (searchText.trim().length > 0) {
          filteredContacts = filteredContacts.filter((contact) =>
            contact.fullName?.toLowerCase().includes(searchText.toLowerCase())
          )
        }

        return filteredContacts
      },

      // Actions utilitaires
      getContactsCount: () => {
        return get().contacts.length
      },

      // Actions de gestion d'état
      setLoading: (loading) => set({ isLoading: loading }),
      
      setError: (error) => set({ error }),

      resetContacts: () => set({ 
        contacts: [], 
        isLoading: false, 
        error: null 
      }),
    })//,
    /*{
      name: 'contactsListStore',
      storage: createJSONStorage(() => AsyncStorage),
    }
  )*/
) 